import { useEffect, useState } from "react";
import { useLazyQuery } from "@apollo/client/react";
import { GET_LIQUIDACIONES_RV_MAIL } from "../../../data/graphQL/queries/LiquidacionFinal/rvMailQueries";

const adaptRow = (item) => ({
    id: item.idLiquidacionProfesional,
    nroLiquidacion: item.idLiquidacionProfesional,
    profesional: item.profesional,
    codigoSap: item.codigoSAPProfesional,
    periodo: item.periodo,
    ocSap: item.numeroOC,
    total: item.total,
    esLegacy: item.esLegacy,
});

export const useGetRows = (filters, setIsRefetchRequired) => {
    const [rows, setRows] = useState([]);
    const [busquedaCompletada, setBusquedaCompletada] = useState(false);

    const [fetchLiquidaciones, { data, loading, error }] = useLazyQuery(
        GET_LIQUIDACIONES_RV_MAIL,
        { fetchPolicy: "network-only" }
    );

    const handleSearch = () => {
        setIsRefetchRequired(false);
        setBusquedaCompletada(false);
        fetchLiquidaciones({
            variables: {
                input: {
                    mes: filters.mes,
                    anio: filters.anio,
                    idTipoProfesional: filters.idTipoProfesional,
                    idDelegacion: filters.idDelegacion,
                }
            },
        });
    };

    useEffect(() => {
        if (data) {
            const adapted = data.liquidacionesRvMail?.valorEsperado?.map(adaptRow) ?? [];
            setRows(adapted);
            setBusquedaCompletada(true);
        }
        if (error) {
            setRows([]);
            setBusquedaCompletada(true);
        }
    }, [data, error]);

    return { handleSearch, rows, loading, busquedaCompletada };
};